import { ITag, IUserSubscribedTags } from '@koomzo/coremodel';

export class LoadTags {
  static readonly type = '[Tags] Load Tags';
}

export class UpdateTags {
  static readonly type = '[Tags] Update Tags';
  constructor(public payload: ITag[]) {}
}

export class LoadUserSubscribedTags {
  static readonly type = '[Tags] Load user subscribed Tags';
}

export class UpdateUserSubscribedTags {
  static readonly type = '[Tags] Update user subscribed Tags';
  constructor(public payload: IUserSubscribedTags) {}
}
